module.exports = __webpack_public_path__ + "img/firstcentralinsurance.731d0669.png";